// extracted by mini-css-extract-plugin
module.exports = {"title":"_2r1O4NlOBipUz6v5z+HcJQ==","item":"B2zGzJxldonlkkGbFIPMug==","text":"_96gO84YmfzM0SX9xyzQt5A=="};